import { BCMSRecord, useBCMSContext, useBCMSModal, useStateManager } from "@bcm-dev/bcms-vite";
import { PageContainer, PageContentView } from "components/shared";
import Classes from "model";
import React, { useEffect } from "react";

import "./styles.css";

/**
 * @function NavigationPage
 * @returns {React.Component}
 * @exported true
 * @description This is a capture only page that allows us to capture the navigation.
 */
export default function NavigationPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui
  });

  return (
    // This page is only used for captures
    <PageContainer className="navigation-page" state={ { data, ui } } controller={ controller }>
      <PageContentView>
        <NavigationContent />
      </PageContentView>
    </PageContainer>
  );
}

export const getDefaultPageData = () => ({});
export const getDefaultPageUI = () => ({
  modal: {
    id: undefined,
    data: {}
  }
});

function NavigationContent(props) {
  const { ui } = useStateManager();
  const { open } = useBCMSModal();

  useEffect(() => {
    if(ui.modal.id !== undefined) {
      open(ui.modal.id, ui.modal.data);
    }
  }, [ ui.modal.id ]);

  return <div></div>;
}